export default {
  scrollBehavior: (to, from, savedPosition) => {
    // Если переход только в пустой хэш, то не скроллить
    if (to.path === from.path && !to.hash) {
      return false
    }

    // В остальных случаях стандартное поведение
    if (savedPosition) {
      return savedPosition
    }

    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }

    return { top: 0 }
  },
}
